// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"21574bb2","506":"79ae22e9","739":"65565801","989":"df970b25"}[chunkId] + ".js";
};